import type { Exam } from '@shared/schemas'
import type { PageProps, QueryDefinition } from '@/core'
import type { ExamsFormValues } from './form'
import type { ExamsVariables } from './variables'

// 1. Tupla QueryDefinition
export type ExamsQueryDefinition = [
  QueryDefinition<'exams', 'query', void, Array<Exam>>,
]

// 2. Endpoint paths
export const EXAM_ENDPOINTS = {
  list: ['api', 'registry/exams'] as [string, string],
  delete: ['api', 'registry/exams'] as [string, string],
  create: ['api', 'registry/exams'] as [string, string],
  update: (id: string): [string, string] => ['api', `registry/exams/${id}`],
  detail: (id: string): [string, string] => ['api', `registry/exams/${id}`],
}

// 3. Query keys
export const EXAM_KEYS = {
  all: ['exams'],
  list: () => EXAM_KEYS.all.join('/'),
  detail: (id: string) => [EXAM_KEYS.all, id].join('/'),
  search: (query: string, limit?: number) =>
    [...EXAM_KEYS.all, 'search', query, limit].join('/'),
}

// 4. Costante queries
export const examsQueries: NonNullable<
  PageProps<ExamsFormValues, ExamsQueryDefinition, ExamsVariables>['queries']
> = [
  {
    key: 'exams',
    type: 'query',
    queryConfig: () => ({
      queryKey: [EXAM_KEYS.list()],
      endpoint: EXAM_ENDPOINTS.list,
      enabled: true,
    }),
  },
]
